<template>
  <ul class="c-product-nutrition c-product-nutrition--extended u-bare-list u-width-70">
    <li
      v-if="isNotEmpty(model.texts.specifiedPer)"
      class="thick-border"
    >
      <strong class="u-font-size-xlarge">{{ model.texts.specifiedPer }}</strong>
    </li>
    <li
      v-if="isNotEmpty(model.specifiedPer)"
      class="no-border"
    >
      <span>{{ model.texts.servingSize }}</span>
      <span>{{ model.specifiedPer }}</span>
    </li>
    <li
      v-if="isNotEmpty(model.texts.amountPer)"
      class="no-border"
    >
      <span>{{ model.texts.amountPer }}</span>
    </li>
    <li
      v-if="isNotEmpty(model.calories && model.calories.amount)"
      class="thick-border u-flex u-flex-justify-space-between"
    >
      <strong class="u-font-size-large">{{ model.texts.calories }}</strong>
      <strong class="u-font-size-large">{{ model.calories && model.calories.amount }}</strong>
    </li>
    <li
      v-if="isNotEmpty(model.texts.percentDailyValue)"
      class="u-flex-justify-end no-border"
    >
      <span>{{ model.texts.percentDailyValue }}</span>
    </li>
    <li
      v-if="isNotEmpty(model.fat && model.fat.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span><strong>{{ model.texts.fat }}</strong> <span style="font-weight: normal;">{{ model.fat && model.fat.amount }}</span></span>
      <strong v-if="model.fat && model.fat.percentDailyValue">({{ model.fat.percentDailyValue }})</strong>
    </li>

    <li
      v-if="isNotEmpty(model.saturatedFat && model.saturatedFat.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.saturatedFat }} <span style="font-weight: normal;">{{ model.saturatedFat && model.saturatedFat.amount }}</span></span>
      <span v-if="model.saturatedFat && model.saturatedFat.percentDailyValue">({{ model.saturatedFat.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.transFat && model.transFat.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">
        <span v-html="transFatText"></span> <span style="font-weight: normal;">{{ model.transFat && model.transFat.amount }}</span>
      </span>
      <span v-if="model.transFat && model.transFat.percentDailyValue">({{ model.transFat.percentDailyValue }})</span>
    </li>

    <li
      v-if="isNotEmpty(model.cholesterol && model.cholesterol.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span><strong>{{ model.texts.cholesterol }}</strong> <span style="font-weight: normal;">{{ model.cholesterol && model.cholesterol.amount }}</span></span>
      <strong v-if="model.cholesterol && model.cholesterol.percentDailyValue">({{ model.cholesterol.percentDailyValue }})</strong>
    </li>
    <li
      v-if="isNotEmpty(model.sodium && model.sodium.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span><strong>{{ model.texts.sodium }}</strong> <span style="font-weight: normal;">{{ model.sodium && model.sodium.amount }}</span></span>
      <strong v-if="model.sodium && model.sodium.percentDailyValue">({{ model.sodium.percentDailyValue }})</strong>
    </li>

    <li
      v-if="isNotEmpty(model.carbohydrate && model.carbohydrate.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span><strong>{{ model.texts.carbohydrate }}</strong> <span style="font-weight: normal;">{{ model.carbohydrate && model.carbohydrate.amount }}</span></span>
      <strong v-if="model.carbohydrate && model.carbohydrate.percentDailyValue">({{ model.carbohydrate.percentDailyValue }})</strong>
    </li>
    <li
      v-if="isNotEmpty(model.fiber && model.fiber.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.fiber }} <span style="font-weight: normal;">{{ model.fiber && model.fiber.amount }}</span></span>
      <span v-if="model.fiber && model.fiber.percentDailyValue">({{ model.fiber.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.sugar && model.sugar.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.sugar }} <span style="font-weight: normal;">{{ model.sugar && model.sugar.amount }}</span></span>
      <span v-if="model.sugar && model.sugar.percentDailyValue">({{ model.sugar.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.addedSugar && model.addedSugar.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--s">{{ model.texts.addedSugar }} <span style="font-weight: normal;">{{ model.addedSugar && model.addedSugar.amount }}</span></span>
      <span v-if="model.addedSugar && model.addedSugar.percentDailyValue">({{ model.addedSugar.percentDailyValue }})</span>
    </li>

    <li
      v-if="isNotEmpty(model.protein && model.protein.amount)"
      class="thick-border u-flex u-flex-justify-space-between"
    >
      <span><strong>{{ model.texts.protein }}</strong> <span style="font-weight: normal;">{{ model.protein && model.protein.amount }}</span></span>
      <strong v-if="model.protein && model.protein.percentDailyValue">({{ model.protein.percentDailyValue }})</strong>
    </li>
    <li
      v-if="isNotEmpty(model.vitaminD && model.vitaminD.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.vitaminD }} <span style="font-weight: normal;">{{ model.vitaminD && model.vitaminD.amount }}</span></span>
      <span v-if="model.vitaminD && model.vitaminD.percentDailyValue">({{ model.vitaminD.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.calcium && model.calcium.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.calcium }} <span style="font-weight: normal;">{{ model.calcium && model.calcium.amount }}</span></span>
      <span v-if="model.calcium && model.calcium.percentDailyValue">({{ model.calcium.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.iron && model.iron.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.iron }} <span style="font-weight: normal;">{{ model.iron && model.iron.amount }}</span></span>
      <span v-if="model.iron && model.iron.percentDailyValue">({{ model.iron.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.salt && model.salt.amount)"
      class="u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.salt }} <span style="font-weight: normal;">{{ model.salt && model.salt.amount }}</span></span>
      <span v-if="model.salt && model.salt.percentDailyValue">({{ model.salt.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.potassium && model.potassium.amount)"
      class="thick-border u-flex u-flex-justify-space-between"
    >
      <span class="u-pl--xs">{{ model.texts.potassium }} <span style="font-weight: normal;">{{ model.potassium && model.potassium.amount }}</span></span>
      <span v-if="model.potassium && model.potassium.percentDailyValue">({{ model.potassium.percentDailyValue }})</span>
    </li>
    <li
      v-if="isNotEmpty(model.texts.percentDailyValueDisclaimer)"
      class="no-border"
    >
      <span>{{ model.texts.percentDailyValueDisclaimer }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    transFatText() {
      const rawText = this.model.texts.transFat || ''
      const words = rawText.split(' ')

      if (words.length === 0) {
        return ''
      }
      if (words.length === 1) {
        return `<em>${words[0]}</em>`
      }

      return `<em>${words[0]}</em> ${words.slice(1).join(' ')}`
    }
  },
  methods: {
    isNotEmpty(value) {
      return value && value !== '0'
    }
  }
}
</script>
